// extracted by mini-css-extract-plugin
module.exports = {"gsapdGroupb":"gsapdGroupb_gsapdGroupb__8Vu51"};